export const buttonTypes = {
  textButton: 'textButton',
  button: 'button',
  node: 'node',
} as const;

export const SHOW_LABEL = {
  hover: 'hover',
  always: 'always',
} as const;

export const dataHooks = {
  item: 'accordion-item',
  header: 'header',
  toggleButton: 'accordion-toggle-button',
  toggleAccordionWrapper: 'toggle-accordion-wrapper',
  // TODO: mismatch for backwards compat, update when major
  prefix: 'icon',
  suffix: 'suffix',
  subtitle: 'accordion-item-subtitle',
} as const;

export const skins = {
  standard: 'standard',
  light: 'light',
  neutral: 'neutral',
} as const;

export const SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const horizontalPaddings = {
  none: 'none',
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const transitionSpeeds = {
  slow: 'slow',
  medium: 'medium',
  fast: 'fast',
} as const;
